import { Locker } from './Locker';
import { useLocker } from '../lockerStore';

/**
 * Mounts the single global Locker instance and wires it to `useLocker`, exactly
 * like `AuthModal` does for the sign-in overlay. Rendered once in RootLayout so
 * the Locker opens from anywhere (avatar menu, Settings) without each caller
 * hosting its own copy.
 */
export function LockerHost() {
  const open = useLocker((s) => s.open);
  const closeLocker = useLocker((s) => s.closeLocker);
  return <Locker open={open} onClose={closeLocker} />;
}
